var _rect, _path, _circle, _circle2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpsell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.53,
    height: 14.6289,
    rx: 2,
    fill: "#FC9E08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 5.92711C13.8381 5.84633 13.7228 5.79438 13.6004 5.77719C13.478 5.76 13.3533 5.77826 13.2406 5.82988L11.1444 7.71931L9.92385 4.53919C9.86643 4.43375 9.78241 4.34589 9.68051 4.28471C9.5786 4.22354 9.4625 4.19128 9.34426 4.19128C9.22602 4.19128 9.10993 4.22354 9.00802 4.28471C8.90611 4.34589 8.82209 4.43375 8.76467 4.53919L7.4127 7.54193L5.44755 5.82967C5.33474 5.77854 5.21019 5.76055 5.08791 5.77772C4.96562 5.79489 4.85046 5.84654 4.7554 5.92685C4.66033 6.00716 4.58913 6.11295 4.5498 6.23231C4.51048 6.35167 4.5046 6.47985 4.53282 6.60243L5.58724 11.1822C5.6073 11.2708 5.64487 11.3544 5.69766 11.4278C5.75044 11.5011 5.81733 11.5627 5.89424 11.6088C5.97155 11.6552 6.05722 11.6853 6.14615 11.6973C6.23509 11.7093 6.32548 11.7029 6.41196 11.6786C8.33025 11.1383 10.3561 11.1382 12.2745 11.678C12.361 11.7023 12.4513 11.7087 12.5402 11.6967C12.6291 11.6847 12.7147 11.6546 12.792 11.6082C12.8689 11.5622 12.9357 11.5006 12.9885 11.4273C13.0413 11.354 13.0789 11.2705 13.099 11.1819L14.1553 6.60294C14.1841 6.48035 14.1785 6.35199 14.1391 6.2325C14.0998 6.11301 14.0284 6.00716 13.9329 5.92711Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.51527,
    cy: 5.26441,
    r: 1.07313,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1735,
    cy: 5.26441,
    r: 1.07313,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.34437,
    cy: 3.65467,
    rx: 1.07313,
    ry: 1.07313,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsell);
export default __webpack_public_path__ + "static/media/upsell.34dc7a02.svg";
export { ForwardRef as ReactComponent };